export const routes = {
  DEFAULT: "/automation",
  CREATE: "/automation/create",
  DETAIL: "/automation/details",
};

export const Trigger = "trigger";
export const inactivateModalText = `Once you make this workflow inactive, you will not be able to make it active again.

Still want to in-activate?`; // added gap in the string purposly
export const saveWorkflowSuccess = `Your workflow has been saved successfully!`;
export const publishWorkflowSuccess = `Your workflow has been published successfully!`;
